import DownloadIcon from "@mui/icons-material/Download";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Skeleton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import debian from "../assets/debian.svg";
import debian_dark from "../assets/debian_dark.svg";
import huawei_light from "../assets/huawei-ar21 1.svg";
import huawei_dark from "../assets/huawei-dark.svg";
import mikrotik from "../assets/mikrotik.svg";
import mikrotik_dark from "../assets/mikrotik_dark.svg";
import tplink_light from "../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../assets/baseVersion/TPLINK_Logo_dark.svg";
import aws_dark from "../assets/baseVersion/AWS_DARK.svg"
import { useNavigate } from "react-router-dom";
import NoData_img1 from "../../src/assets/baseVersion/Nodata.svg";
import CIS_image from "../assets/comp_cis_light.svg";
import CIS_dark from "../assets/comp_cis_dark.svg";
import axiosInstance from "../axios/axios";
import PCI_DSS_logo from "../assets/PCI_DSS_logo.svg";

// Removed unused imports that were only needed for inline ComplianceTrends component
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import NIST_image from "../assets/comp_nist_light.svg";
import NIST_dark from "../assets/comp_nist_dark.svg";
import { Tags } from "../modules/dashboard";
import ComplianceTrendsComponent from "./Dashboard/compliancetrends";

import { END_POINTS } from "../shared";
import { setComplianceWidget } from "./onPremises/ComplianceWidget.slice";

import AgGridTable from "../components/table/AgGridTable";
import useRolePermissions from "../shared/hooks/useRolePermissions";
import { ROLES_ROUTE } from "../shared/constants/constant-data";

import AppsIcon from "@mui/icons-material/Apps";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
// import Cisco_img from "../../../assets/baseVersion/cisco.svg";
import Cisco_img from "../assets/baseVersion/cisco.svg";
import Paloalto_img from "../assets/baseVersion/paloalto.svg";
import Paloalto_dark from "../assets/palaoto_dark.svg";
import arista_img from "../assets/baseVersion/arista.svg";
import arista_dark from "../assets/arista_dark.svg";

import AWS_img from "../assets/baseVersion/aws.svg";
import AWS_DARK from "../assets/baseVersion/AWS_DARK.svg"
import juniper_assets from "../assets/juniper.svg";
import juniper_dark from "../assets/baseVersion/dark_juniper.svg";
import fortinet_img from "../assets/fortinet.svg";
import fortinet_scan_dark from "../assets/fortinet-white-1.svg"
import eventEmitter from "../components/utils/eventEmitter";
import sophosLogo from "../assets/sophos.svg";
import sophos_dark from "../assets/sophos-white.svg";
import { RootState } from "../store/store";
import ubuntu from "../assets/ubuntu.svg";
import ubuntu_dark from "../assets/ubuntu_dark.svg";
import ubuntu_light from "../assets/ubuntu_white.svg";
import windows_dark from "../assets/baseVersion/Windows_dark.svg"
import Windows_light from "../assets/baseVersion/Windows_light.svg"
import redhat_light from "../assets/redhat_light.svg";
import redhat_dark from "../assets/redhat_dark.svg";
import apple_img from "../assets/apple.svg";
import apple_dark from "../assets/apple_dark.svg";
import dell_logo from "../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../assets/syrotech_light.svg";
import syrotech_dark from "../assets/syrotech_dark.svg";
import WhiteTooltip from "../components/WhiteTooltip";
import Loading from "../components/loader/loading";
import DoTDashboardCard from "./DoTCompliance/DoTDashboardCard";


dayjs.extend(isBetween);

const CD_COMPLIANCE_POSTURE = "/securityscan/cd-compliance-posture";

type ControlVersion = {
  id: string;
  version: string;
};

type FilterOption = {
  id: string;
  name: string;
};

type ControlType = {
  id: string;
  name: string;
  versions: ControlVersion[];
  filter: FilterOption[] | null;
};

interface ComplianceSummary {
  id: string;
  control_type: string;
  compliance: number;
  stage: string;
  type: string[];
  passed_count: number;
  failed_count: number;
  total_count: number;
  control_type_id: string;
  version_id: string;
}

interface ComplianceFiltersResponse {
  status: number;
  message: string;
  data: {
    control_types: ControlType[];
  };
}

interface CompliancePostureResponse {
  status: number;
  message: string;
  data: {
    compliance_data: {
      total_count: number;
      passed_count: number;
      failed_count: number;
      compliance: number;
      control_type_id: string;
      control_type: string;
      version_id: string;
      version: string;
      filter: string;
    };
  };
}

interface ComplianceTrendData {
  date: string;
  CIS_V8: number;
  "NIST 800-53": number;
  "NIST 800-171": number;
  // "PCI-DSS": number;
}

interface MisconfigurationData {
  indexes: any[];
}

// Mock trend data
const mockTrendData = [
  {
    date: "01-06",
    CIS_V8: 76,
    "NIST 800-53": 68,
    "NIST 800-171": 45,
    // "PCI-DSS": 35,
  },
  {
    date: "01-05",
    CIS_V8: 65,
    "NIST 800-53": 55,
    "NIST 800-171": 48,
    // "PCI-DSS": 42,
  },
  {
    date: "02-05",
    CIS_V8: 70,
    "NIST 800-53": 58,
    "NIST 800-171": 52,
    // "PCI-DSS": 38,
  },
  {
    date: "03-05",
    CIS_V8: 68,
    "NIST 800-53": 62,
    "NIST 800-171": 55,
    // "PCI-DSS": 45,
  },
  {
    date: "04-05",
    CIS_V8: 72,
    "NIST 800-53": 65,
    "NIST 800-171": 58,
    // "PCI-DSS": 48,
  },
  {
    date: "05-05",
    CIS_V8: 75,
    "NIST 800-53": 70,
    "NIST 800-171": 60,
    // "PCI-DSS": 52,
  },
];

const mockEmptyComplianceData = (controlTypes: ControlType[]) => {
  return controlTypes.flatMap((controlType) =>
    controlType.versions.map((version) => {
      // Generate random values between 40-90 for compliance
      const compliance = Math.floor(Math.random() * (90 - 40 + 1)) + 40;
      // Generate random total count between 50-200
      const totalCount = Math.floor(Math.random() * (200 - 50 + 1)) + 50;
      // Calculate passed and failed counts based on compliance percentage
      const passedCount = Math.round((compliance / 100) * totalCount);
      const failedCount = totalCount - passedCount;

      return {
        id: version.id,
        control_type: controlType.name,
        compliance: compliance,
        stage: `${controlType.name} ${version.version}`,
        type: controlType.filter ? controlType.filter.map((f) => f.name) : [],
        passed_count: passedCount,
        failed_count: failedCount,
        total_count: totalCount,
        control_type_id: controlType.id,
        version_id: version.id,
      };
    })
  );
};

interface ComplianceWidgetProps {
  data: ComplianceSummary;
  controlTypes: ControlType[];
  setComplianceData: React.Dispatch<React.SetStateAction<ComplianceSummary[]>>;
}

const ComplianceWidget = ({
  data,
  controlTypes,
  setComplianceData,
}: ComplianceWidgetProps) => {
  console.log("ComplianceWidget data:", data);
  console.log("ComplianceWidget controlTypes:", controlTypes);
  const [filterEnabled, setFilterEnabled] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(
    data.type[data.type.length - 1] || ""
  );
  const [compliancePercentage, setCompliancePercentage] = useState(
    data.compliance
  );
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Update compliance percentage when data changes
  useEffect(() => {
    setCompliancePercentage(data.compliance);
  }, [data.compliance]);




  const chartOptions = React.useMemo(
    () => ({
      chart: {
        height: 170,
        type: "radialBar" as const,
        toolbar: {
          show: false,
        },
        background: "transparent",
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: "70%",
            background:
              theme.palette.mode === "dark"
                ? "rgba(255, 255, 255, 0.05)"
                : "#fff",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front" as const,
            dropShadow: {
              enabled: false,
            },
          },
          track: {
            background:
              theme.palette.mode === "dark"
                ? "rgba(255, 255, 255, 0.1)"
                : "#eee",
            strokeWidth: "100%",
            margin: 0,
            dropShadow: {
              enabled: false,
            },
          },
          dataLabels: {
            show: true,
            name: {
              show: true,
              fontSize: "16px",
              fontWeight: 400,
              offsetY: 20,
              color: theme.palette.mode === "dark" ? "#fff" : "#888",
            },
            value: {
              show: true,
              fontSize: "25px",
              fontWeight: 600,
              color: theme.palette.mode === "dark" ? "#fff" : "#2E2E2E",
              offsetY: -20,
              formatter: function (val: number) {
                return Math.round(val) + "%";
              },
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: ["#B4C3D1"],
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round" as const,
      },
      colors: ["#55718B"],
      labels: ["Compliance%"],
    }),
    [theme.palette.mode]
  );

  const chartSeries = React.useMemo(
    () => [compliancePercentage],
    [compliancePercentage]
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFilterSelect = async (filter: string) => {
    setSelectedFilter(filter);
    setShowDropdown(false);

    // Find the control type and version for this widget
    const controlType = controlTypes.find(
      (ct: ControlType) => ct.name === data.control_type
    );
    if (controlType) {
      const version = controlType.versions.find(
        (v: ControlVersion) => v.id === data.id
      );
      if (version) {
        try {
          const payload = {
            control_type: controlType.id,
            version: version.id,
            filter: filter,
          };

          console.log(
            "Making API call to /securityscan/cd-compliance-posture with payload:",
            payload
          );
          console.log("Selected filter:", filter);
          const response = await axiosInstance.post<CompliancePostureResponse>(
            "/securityscan/cd-compliance-posture",
            payload
          );

          console.log("API Response:", response.data);

          if (response.data && response.data.data) {
            const complianceData = response.data.data.compliance_data;
            // Update the widget data with new compliance information
            setComplianceData((prevData: ComplianceSummary[]) =>
              prevData.map((item: ComplianceSummary) =>
                item.id === data.id
                  ? {
                    ...item,
                    compliance: Math.round(complianceData.compliance),
                    passed_count: Math.round(complianceData.passed_count),
                    failed_count: Math.round(complianceData.failed_count),
                    total_count: Math.round(complianceData.total_count),
                  }
                  : item
              )
            );
            // Update the local compliance percentage
            setCompliancePercentage(Math.round(complianceData.compliance));
          }
        } catch (error) {
          console.error(
            `Error fetching compliance data for ${data.control_type} ${version.version}:`,
            error
          );
        }
      }
    }
  };

  const getControlImage = (controlType: string) => {
    switch (controlType.toUpperCase()) {
      case "CIS":
        return isDarkMode ? CIS_dark : CIS_image;
      case "NIST":
        return isDarkMode ? NIST_dark : NIST_image;
      case "PCI DSS":
        return PCI_DSS_logo;
      default:
        return undefined;
    }
  };

  const dispatch = useDispatch();

  const handleCardClick = () => {
    console.log("Card clicked:", data.control_type);
    console.log(data);
    console.log(data, "data.stage);");
    navigate(`/compliance-dashboard/${encodeURIComponent(data.control_type)}?type=${encodeURIComponent(data.stage)}`);

    dispatch(
      setComplianceWidget({
        Control_id: data.control_type_id,
        Version_id: data.version_id,
        framework: data.stage,
      })
    );
  };

  return (
    <Box
      sx={{
        borderRadius: 2.5,
        p: 2,
        height: "100%",
        width: "100%",
        aspectRatio: "1/1",
        border: `1px solid ${theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.1)"
          : "rgba(0, 0, 0, 0.1)"
          }`,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
        cursor: "pointer",
        bgcolor:
          theme.palette.mode === "dark"
            ? "#191C24"
            : "#FFFFFF",
      }}
      onClick={(e) => {
        // Only navigate if we didn't click on or inside the dropdown area
        if (!dropdownRef.current?.contains(e.target as Node)) {
          handleCardClick();
        }
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.5,
          width: "100%",
          gap: 2
        }}
      >
        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          minWidth: 0,
          flex: "1 1 auto",
          overflow: "hidden"
        }}>
          {getControlImage(data.control_type) && (
            <img
              src={getControlImage(data.control_type)}
              alt={data.control_type}
              style={{ height: 18, flexShrink: 0 }}
            />
          )}
          <Typography
            noWrap
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              color: theme.palette.mode === "dark" ? "#fff" : "inherit",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {data.stage}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            zIndex: 2,
            flex: "0 0 auto",
            marginRight: -7
          }}
          ref={dropdownRef}
        >
          {data.type && data.type.length > 0 && (
            <>
              <Box
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowDropdown(!showDropdown);
                }}
                onTouchStart={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  // padding: "4px 8px",
                  borderRadius: 1,
                  minWidth: 90,
                  userSelect: "none",
                  WebkitTapHighlightColor: "transparent",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    "& .dropdown-text, & .dropdown-icon": {
                      color: theme.palette.mode === "dark"
                        ? "rgba(255, 255, 255, 1)"
                        : "rgba(0, 0, 0, 0.9)"
                    }
                  },
                  "&:active": {
                    transform: "scale(0.98)"
                  }
                }}
              >
                <Typography
                  className="dropdown-text"
                  sx={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.9)"
                      : "#374151",
                    transition: "color 0.2s",
                    userSelect: "none",
                    mr: 0.5
                  }}
                >
                  {selectedFilter}
                </Typography>
                <KeyboardArrowDownIcon
                  className="dropdown-icon"
                  sx={{
                    fontSize: 18,
                    transform: showDropdown ? "rotate(180deg)" : "none",
                    transition: "transform 0.2s",
                    color: theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.7)"
                      : "#6B7280"
                  }}
                />
              </Box>
              <Menu
                anchorEl={dropdownRef.current}
                open={showDropdown}
                onClose={(e: React.MouseEvent<HTMLElement>) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowDropdown(false);
                }}
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                slotProps={{
                  paper: {
                    onClick: (e: { preventDefault: () => void; stopPropagation: () => void }) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }
                }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: dropdownRef.current?.offsetWidth,
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    bgcolor: theme.palette.mode === "dark"
                      ? "#1F2937"
                      : "#FFFFFF",
                  },
                }}
                MenuListProps={{
                  sx: {
                    py: 0.5
                  }
                }}
              >
                {data.type.map((filter) => (
                  <MenuItem
                    key={filter}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleFilterSelect(filter);
                    }}
                    onTouchStart={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    selected={selectedFilter === filter}
                    sx={{
                      fontSize: "13px",
                      fontWeight: 500,
                      py: 1,
                      px: 2,
                      width: "100%",
                      cursor: "pointer",
                      userSelect: "none",
                      WebkitTapHighlightColor: "transparent",
                      color: selectedFilter === filter
                        ? theme.palette.mode === "dark"
                          ? "#B4C3D1"
                          : "#2563EB"
                        : theme.palette.mode === "dark"
                          ? "rgba(255, 255, 255, 0.9)"
                          : "#374151",
                      "&:hover": {
                        bgcolor: theme.palette.mode === "dark"
                          ? "rgba(255, 255, 255, 0.15)"
                          : "rgba(0, 0, 0, 0.08)",
                      },
                      "&:active": {
                        bgcolor: theme.palette.mode === "dark"
                          ? "rgba(255, 255, 255, 0.2)"
                          : "rgba(0, 0, 0, 0.12)",
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    {filter}
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}
          <IconButton size="small" sx={{ p: 0.5 }}>
            {/* <DownloadIcon
              sx={{
                fontSize: 14,
                color: theme.palette.mode === "dark" ? "#B4C3D1" : "#2563EB",
              }}
            /> */}
          </IconButton>
        </Box>
      </Box>

      {/* ApexCharts RadialBar */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          my: 0.5,
          mt: -5,
        }}
      >
        <ReactApexChart
          options={chartOptions}
          series={chartSeries}
          type="radialBar"
          height={210}
        />
      </Box>

      {/* Statistics */}
      <Box sx={{ mt: -5, display: "flex", flexDirection: "column", gap: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            color:
              theme.palette.mode === "dark"
                ? "rgba(255, 255, 255, 0.7)"
                : "#6B7280",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            Passed:{" "}
            <span
              style={{
                color: theme.palette.mode === "dark" ? "#4ADE80" : "#059669",
                fontWeight: 600,
              }}
            >
              {data.passed_count}
            </span>
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            Failed:{" "}
            <span
              style={{
                color: theme.palette.mode === "dark" ? "#F87171" : "#DC2626",
                fontWeight: 600,
              }}
            >
              {data.failed_count}
            </span>
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            color:
              theme.palette.mode === "dark"
                ? "rgba(255, 255, 255, 0.9)"
                : "#374151",
            textAlign: "left",
            width: "100%",
            pt: 1,
          }}
        >
          Total Controls: {data.total_count}
        </Typography>
      </Box>
    </Box>
  );
};

const ComplianceWidgetSkeleton = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        bgcolor:
          theme.palette.mode === "dark"
            ? "#191C24"
            : "#FFFFFF",
        borderRadius: 4,
        p: 2,
        height: "100%",
        width: "100%",
        aspectRatio: "1/1",
        border: `1px solid ${theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.1)"
          : "rgba(0, 0, 0, 0.1)"
          }`,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Header Skeleton */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Skeleton variant="circular" width={18} height={18} />
          <Skeleton variant="text" width={100} height={20} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Skeleton
            variant="rectangular"
            width={100}
            height={30}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton variant="circular" width={20} height={20} />
        </Box>
      </Box>

      {/* Progress Circle Skeleton */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          my: 0.5,
          mt: -5,
        }}
      >
        <Skeleton variant="circular" width={170} height={170} />
      </Box>

      {/* Bottom Stats Skeleton */}
      <Box sx={{ mt: -5, display: "flex", flexDirection: "column", gap: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </Box>
        <Skeleton variant="text" width={120} height={20} />
      </Box>
    </Box>
  );
};

const ComplianceTrendsSkeleton = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        bgcolor:
          theme.palette.mode === "dark"
            ? "#191C24"
            : "#FFFFFF",
        borderRadius: 2,
        p: 3,
        height: "100%",
        border: `1px solid ${theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.1)"
          : "rgba(0, 0, 0, 0.1)"
          }`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header Skeleton */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Skeleton variant="text" width={200} height={32} />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>

      {/* Chart Area Skeleton */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
        {/* X-axis labels */}
        <Box sx={{ display: "flex", justifyContent: "space-between", px: 2 }}>
          {[1, 2, 3, 4, 5, 6].map((_, index) => (
            <Skeleton key={index} variant="text" width={40} height={20} />
          ))}
        </Box>

        {/* Chart area with grid lines */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `linear-gradient(to right, ${theme.palette.mode === "dark"
                ? "rgba(255, 255, 255, 0.05)"
                : "rgba(0, 0, 0, 0.05)"
                } 1px, transparent 1px),
                            linear-gradient(to bottom, ${theme.palette.mode === "dark"
                  ? "rgba(255, 255, 255, 0.05)"
                  : "rgba(0, 0, 0, 0.05)"
                } 1px, transparent 1px)`,
              backgroundSize: "20% 20%",
            },
          }}
        >
          {/* Line chart skeletons */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              p: 2,
            }}
          >
            {[1, 2, 3, 4].map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                height={2}
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  bgcolor:
                    theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.1)"
                      : "rgba(0, 0, 0, 0.1)",
                }}
              />
            ))}
          </Box>
        </Box>

        {/* Legend Skeleton */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 2 }}>
          {[1, 2, 3, 4].map((_, index) => (
            <Box
              key={index}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Skeleton variant="circular" width={12} height={12} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

// Inline ComplianceTrends component removed - using shared component instead

const AssetsTable = () => {
  const [rowData, setRowData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [nistColumns, setNistColumns] = useState<any[]>([]);
  const [cisColumns, setCisColumns] = useState<any[]>([]);
  const [complianceColumns, setComplianceColumns] = useState<any[]>([]);
  const [complianceColumnDefs, setComplianceColumnDefs] = useState<any[]>([]);
  const [selectedCompliance, setSelectedCompliance] = useState<string>("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const baseColumnDefs = [
    // {
    //   field: "device_name",
    //   headerName: "Name",
    //   flex: 1,
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    //   cellRenderer: (param: any) => {
    //     const value = param.value || "";
    //     // Show ellipsis only if value is long and cell is not wide enough
    //     // If the cell has enough width (e.g., after dragging), show full value
    //     const cellWidth = param?.eGridCell?.offsetWidth || 0;
    //     const showEllipsis = value.length > 10 && cellWidth < 150;
    //     return (
    //       <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
    //         <Box
    //           sx={{
    //             width: "4px",
    //             height: "24px",
    //             backgroundColor: "#00A61B",
    //             borderRadius: "2px",
    //           }}
    //         />
    //         <span
    //           style={{
    //             maxWidth: 120,
    //             overflow: "hidden",
    //             textOverflow: showEllipsis ? "ellipsis" : "unset",
    //             whiteSpace: "nowrap",
    //             display: "inline-block",
    //             verticalAlign: "middle",
    //           }}
    //           title={value}
    //         >
    //           {value}
    //         </span>
    //       </Box>
    //     );
    //   },
    // },
    {
      field: "device_name",
      headerName: "Name",
      filter: true,
      minWidth: 200,
      width: 200,
      flex: 1,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "";
        const parameterType = params.data?.parameter_type || "";
        const isManual = parameterType === "Manual";
        const color = isManual ? "#F7941F" : "#696595";
        const bgcolor = isManual ? "#F7941F" : "#696595";

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: 8,
            }}
          >
            <WhiteTooltip title={value}>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  flex: 1,
                  cursor: "default",
                }}
              >
                {value}
              </Typography>
            </WhiteTooltip>

          </div>
        );
      }
    },
    {
      field: "type",
      headerName: "Type",
      valueGetter: (params: any) => {
        const vendor = params.data.vendor || "";
        const model = params.data.model;
        return model ? `${vendor}-${model}` : vendor;
      },
      cellRenderer: (params: any) => {
        const vendor = params.data.vendor
          ? params.data.vendor.toLowerCase()
          : "";
        const model = params.data.model;
        let imgSrc = "";
        if (vendor === "cisco") {
          imgSrc = Cisco_img;
        } else if (vendor === "paloalto" || vendor === "palo alto" || vendor === "Palo Alto") {
          imgSrc = isDarkMode ? Paloalto_dark : Paloalto_img;
        } else if (vendor === "amazon web services") {
          imgSrc = isDarkMode ? AWS_DARK : AWS_img;
        } else if (vendor === "arista") {
          imgSrc = isDarkMode ? arista_dark : arista_img;
        } else if (vendor === "juniper") {
          imgSrc = isDarkMode ? juniper_dark : juniper_assets;
        }
        else if (vendor === "fortinet") {
          imgSrc = isDarkMode ? fortinet_scan_dark : fortinet_img;
        } else if (vendor === "sophos") {
          imgSrc = isDarkMode ? sophos_dark : sophosLogo;
        } else if (vendor === "ubuntu") {
          imgSrc = isDarkMode ? ubuntu_dark : ubuntu_light;
        }
        else if (vendor === "microsoft") {
          imgSrc = isDarkMode ? windows_dark : Windows_light;
        } else if (vendor === "debian") {
          imgSrc = isDarkMode ? debian_dark : debian;
        } else if (vendor === "redhat") {
          imgSrc = isDarkMode ? redhat_dark : redhat_light;
        } else if (vendor === "huawei") {
          imgSrc = isDarkMode ? huawei_dark : huawei_light;
        } else if (vendor === "mikrotik") {
          imgSrc = isDarkMode ? mikrotik_dark : mikrotik;
        } else if (vendor === "tp-link" || vendor === "tplink") {
          imgSrc = isDarkMode ? tplink_dark : tplink_light;
        } else if (vendor === "apple" || vendor === "macos") {
          imgSrc = isDarkMode ? apple_dark : apple_img;
        } else if (vendor === "dell") {
          imgSrc = dell_logo;
        } else if (vendor === "syrotech") {
          imgSrc = isDarkMode ? syrotech_dark : syrotech_light;
        }
        const typeValue = model
          ? `${params.data.vendor}-${model}`
          : params.data.vendor;
        const showEllipsis = typeValue && typeValue.length > 10;
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%", justifyContent: imgSrc ? "flex-start" : "center" }}>
            {imgSrc && (
              <img
                src={imgSrc}
                alt={vendor}
                style={{
                  cursor: "default",
                  height:
                    vendor === "sophos"
                      ? 80
                      : vendor === "fortinet"
                        ? 45
                        : vendor === "amazon web services"
                          ? 30
                          : 30,
                  width: vendor === "sophos" ? 70 : vendor === "fortinet" ? 45 : vendor === "huawei" ? 90 : 30,
                  objectFit: "contain",
                }}
              />
            )}
            <span
              style={{
                maxWidth: 120,
                fontSize: 16,
                fontWeight: 600,
                overflow: "hidden",
                textOverflow: showEllipsis ? "ellipsis" : "unset",
                whiteSpace: "nowrap",
                display: "inline-block",
                verticalAlign: "middle",
                cursor: "default",
                textAlign: imgSrc ? "left" : "center",
              }}
              title={showEllipsis ? typeValue : undefined}
            >
              {typeValue}
            </span>
          </Box>
        );

      },
      flex: 1,
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  ];

  const generateComplianceColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    // Collect all unique keys from all rows
    const allKeysSet = new Set<string>();
    data.forEach((row) => {
      Object.keys(row).forEach((key) => {
        if (key.startsWith("NIST_") || key.startsWith("CIS_") || key.startsWith("PCI") || key.startsWith("SPARK_")) {
          allKeysSet.add(key);
        }
      });
    });
    const allKeys = Array.from(allKeysSet);
    const nistKeys = allKeys.filter((key) => key.startsWith("NIST_"));
    const cisKeys = allKeys.filter((key) => key.startsWith("CIS_"));

    setNistColumns(nistKeys);
    setCisColumns(cisKeys);
    const allDefs = allKeys.map((key) => ({
      field: key,
      valueGetter: key.includes(".") ? (params: any) => params.data[key] : undefined,
      headerName: key,
      flex: 1,
      cellRenderer: (params: any) => {
        // Use the same logic as ComplianceCellRenderer
        const value = Number(params.value) || 0;
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
              cursor: "default",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
                cursor: "default",
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: "#00A61B",
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600} >
              {`${value}%`}
            </Typography>
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
    setComplianceColumns(allKeys);
    setComplianceColumnDefs(allDefs);
    // Set initial selected compliance column
    if (allKeys.length > 0) setSelectedCompliance(allKeys[0]);
  };
  const [trigger, setTrigger] = useState(0); // Used to re-trigger the effect
  useEffect(() => {
    const handleFilterSaved = () => {
      setIsLoading(true);
      setTrigger((prev) => prev + 1); // Changing this will re-trigger the effect
    };

    eventEmitter.on("filterSaved", handleFilterSaved);

    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          "/securityscan/dashboard-assets-compliance",
          // {
          //   params: {
          //     module: "on_premise", // Add module parameter to prevent 503 error
          //     page: 1,
          //     page_size: 100, // Get more data for this dashboard view
          //   }
          // }
        );
        if (response.data?.data?.device_list) {
          const formattedData = response.data.data.device_list.map(
            (device: any) => ({
              ...device,
              compliance: Math.round(
                ((Number(device.CIS_8) || 0) +
                  (Number(device["CIS_7.1"]) || 0) +
                  (Number(device["NIST_800-53 r4"]) || 0) +
                  (Number(device["NIST_800-53 r5"]) || 0) +
                  (Number(device["NIST_800-171 r2"]) || 0) +
                  (Number(device["PCI DSS_4.0.1"]) || 0) +
                  (Number(device["SPARK_1"]) || 0)) / 7
              ),
            })
          );
          setRowData(formattedData);
          generateComplianceColumns(formattedData);
        }
      } catch (error: any) {
        console.error("Error fetching assets data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [trigger]);

  // Find the selected compliance column definition
  const selectedComplianceDef = complianceColumnDefs.find(
    (col) => col.field === selectedCompliance
  );
  const columnDefs = selectedComplianceDef
    ? [...baseColumnDefs, selectedComplianceDef]
    : baseColumnDefs;

  // Menu handlers
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleComplianceSelect = (col: string) => {
    setSelectedCompliance(col);
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        bgcolor:
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.05)"
            : "#FFFFFF",
        borderRadius: 2,
        border: `1px solid ${theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.1)"
          : "rgba(0, 0, 0, 0.1)"
          }`,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          p: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: `1px solid ${theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.1)"
            : "rgba(0, 0, 0, 0.1)"
            }`,
          minHeight: 36,
          height: 36,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: "bold", fontSize: "16px", lineHeight: 1.2 }}
        >
          Assets with Compliance
        </Typography>
        <IconButton
          onClick={handleMenuOpen}
          sx={{
            color: theme.palette.mode === "dark" ? "#696595" : "#373757",
            "&:hover": {
              backgroundColor:
                theme.palette.mode === "dark"
                  ? "rgba(255, 255, 255, 0.1)"
                  : "rgba(37, 99, 235, 0.1)",
            },
            borderRadius: 2,
            padding: 0.5,
          }}
        >
          <AppsIcon fontSize="medium" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {complianceColumns.map((col) => (
            <MenuItem
              key={col}
              selected={col === selectedCompliance}
              onClick={() => handleComplianceSelect(col)}
            >
              {col}
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <Box sx={{ flex: 1, p: 0, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <AgGridTable
          columnDefs={columnDefs}
          data={rowData}
          showSearch={false}
          isRowSelectable={false}
          pagination={true}
          showAppsIcon={false}
          height="100%"
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
};

const ComplianceDashboard: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { hasPermissions } = useRolePermissions();
  const [trigger, setTrigger] = useState(0); // Used to re-trigger the effect
  const [complianceData, setComplianceData] = useState<ComplianceSummary[]>([]);
  const [trendData, setTrendData] =
    useState<ComplianceTrendData[]>(mockTrendData);
  const [loading, setLoading] = useState(true);
  const [misConfigData, setMisConfigData] = useState<MisconfigurationData>({
    indexes: [],
  });
  const [controlTypes, setControlTypes] = useState<ControlType[]>([]);

  const fetchComplianceData = async (
    controlType: ControlType,
    version: ControlVersion,
    filter?: FilterOption
  ) => {
    try {
      const payload = {
        control_type: controlType.id,
        version: version.id,
        filter: filter?.id || null,
      };

      console.log(
        "Making API call to /securityscan/cd-compliance-posture with payload:",
        payload
      );

      const response = await axiosInstance.post<CompliancePostureResponse>(
        "/securityscan/cd-compliance-posture",
        payload
      );

      console.log("API Response:", response.data);

      if (response.data && response.data.data) {
        const complianceData = response.data.data.compliance_data;
        if (
          complianceData?.compliance === null ||
          complianceData?.compliance === undefined
        ) {
          return null;
        }
        const roundedCompliance = Math.round(complianceData.compliance);
        return {
          id: version.id,
          control_type: controlType.name,
          compliance: roundedCompliance,
          stage: `${controlType.name} ${version.version}`,
          type: controlType.filter ? controlType.filter.map((f) => f.name) : [],
          passed_count: Math.round(complianceData.passed_count),
          failed_count: Math.round(complianceData.failed_count),
          total_count: Math.round(complianceData.total_count),
        };
      }
      return null;
    } catch (error) {
      console.error("Error fetching compliance data:", error);
      return null;
    }
  };

  useEffect(() => {
    const handleFilterSaved = () => {
      setLoading(true); // 🔥 Show skeleton loader immediately
      setTrigger((prev) => prev + 1); // Changing this will re-trigger the effect
    };

    eventEmitter.on("filterSaved", handleFilterSaved);

    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // First get the compliance filters
        const complianceFiltersResponse = await axiosInstance.get(
          "/securityscan/compliance-filters"
        );

        if (
          complianceFiltersResponse.data &&
          complianceFiltersResponse.data.data
        ) {
          // Filter out PCI DSS control type
          // const controlTypesData = complianceFiltersResponse.data.data.control_types.filter(
          //   (ct: ControlType) => ct.name !== "PCI DSS"
          // );
          const controlTypesData =
            complianceFiltersResponse.data.data.control_types;
          setControlTypes(controlTypesData);
          setControlTypes(controlTypesData);

          // Comment out mock PCI DSS control type
          // const mockPciDss = {
          //   id: "pci_dss_mock",
          //   name: "PCI DSS",
          //   versions: [
          //     {
          //       id: "pci_dss_v4",
          //       version: "v4.0",
          //     }
          //   ],
          //   filter: null
          // };

          // Create initial compliance data without PCI DSS
          const initialComplianceData = controlTypesData.flatMap(
            (controlType: ControlType) =>
              controlType.versions.map((version: ControlVersion) => ({
                id: version.id,
                control_type: controlType.name,
                compliance: 0,
                stage: `${controlType.name} ${version.version}`,
                type: controlType.filter
                  ? controlType.filter.map((f) => f.id)
                  : [],
                passed_count: 0,
                failed_count: 0,
                total_count: 0,
                control_type_id: controlType.id,
                version_id: version.id,
              }))
          );
          setComplianceData(initialComplianceData);

          // Try to fetch compliance posture data for each control type and version
          const compliancePromises = controlTypesData.flatMap(
            (controlType: ControlType) =>
              controlType.versions.map(async (version: ControlVersion) => {
                try {
                  // Comment out PCI DSS mock data generation
                  // if (controlType.name === "PCI DSS") {
                  //   const mockCompliance = 45;
                  //   const mockTotalCount = 85;
                  //   const mockPassedCount = 25;
                  //   const mockFailedCount = mockTotalCount - mockPassedCount;

                  //   return {
                  //     id: version.id,
                  //     version_id: version.id,
                  //     control_type_id: controlType.id,
                  //     control_type: controlType.name,
                  //     compliance: mockCompliance,
                  //     stage: `${controlType.name} ${version.version}`,
                  //     type: [],
                  //     passed_count: mockPassedCount,
                  //     failed_count: mockFailedCount,
                  //     total_count: mockTotalCount,
                  //   };
                  // }

                  const payload = {
                    control_type: controlType.id,
                    version: version.id,
                    filter:
                      controlType.filter && controlType.filter.length > 0
                        ? controlType.filter[controlType.filter.length - 1].id
                        : null,
                  };

                  const response = await axiosInstance.post<CompliancePostureResponse>(
                    "/securityscan/cd-compliance-posture",
                    payload
                  );

                  if (response.data && response.data.data) {
                    const complianceData = response.data.data.compliance_data;
                    if (
                      complianceData?.compliance === null ||
                      complianceData?.compliance === undefined
                    ) {
                      return null;
                    }
                    const roundedCompliance = Math.round(complianceData.compliance);
                    return {
                      id: version.id,
                      version_id: complianceData.version_id,
                      control_type_id: complianceData.control_type_id,
                      control_type: controlType.name,
                      compliance: roundedCompliance,
                      stage: `${controlType.name} ${version.version}`,
                      type: controlType.filter
                        ? controlType.filter.map((f) => f.id)
                        : [],
                      passed_count: Math.round(complianceData.passed_count),
                      failed_count: Math.round(complianceData.failed_count),
                      total_count: Math.round(complianceData.total_count),
                    };
                  }
                  return null;
                } catch (error) {
                  console.error(
                    `Error fetching compliance data for ${controlType.name} ${version.version}:`,
                    error
                  );
                  return null;
                }
              })
          );

          const complianceResults = await Promise.all(compliancePromises);
          const validComplianceData = complianceResults.filter(
            (data): data is ComplianceSummary => data !== null
          );
          // Sort the compliance data to put PCI DSS first
          const sortedComplianceData = validComplianceData.sort((a, b) => {
            if (a.control_type === "PCI DSS") return -1;
            if (b.control_type === "PCI DSS") return 1;
            return 0;
          });
          setComplianceData(sortedComplianceData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [trigger]);

  const trendChartOptions = {
    chart: {
      height: 350,
      type: "line" as const,
      toolbar: {
        show: false,
      },
      background: "transparent",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth" as const,
    },
    grid: {
      borderColor:
        theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "#e7e7e7",
      row: {
        colors: [
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.05)"
            : "#f3f3f3",
          "transparent",
        ],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: trendData.map((d) => d.date),
      labels: {
        style: {
          colors:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.7)"
              : "#6B7280",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val: number) {
          return val + "%";
        },
        style: {
          colors:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.7)"
              : "#6B7280",
        },
      },
      min: 0,
      max: 100,
    },
    colors:
      theme.palette.mode === "dark"
        ? ["#B4C3D1", "#8B9EB0", "#6B7D8F", "#4A5C6E"]
        : ["#55718B", "#B4C3D1", "#6366F1", "#FB923C"],
    legend: {
      position: "bottom" as const,
      horizontalAlign: "center" as const,
      offsetY: 10,
      itemMargin: {
        horizontal: 10,
      },
      labels: {
        colors:
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.7)"
            : "#6B7280",
      },
    },
  };

  const trendChartSeries = [
    {
      name: "CIS v8",
      data: trendData.map((d) => Math.round(d.CIS_V8)),
    },
    {
      name: "NIST 800-53",
      data: trendData.map((d) => Math.round(d["NIST 800-53"])),
    },
    {
      name: "NIST 800-171",
      data: trendData.map((d) => Math.round(d["NIST 800-171"])),
    },
    // {
    //   name: "PCI-DSS",
    //   data: trendData.map((d) => Math.round(d["PCI-DSS"])),
    // },
  ];


  const isNewUserTrue = useSelector(
    (state: RootState) => state.UserLoginDetails.isNewUserTrue
  );
  const isOnlyCloudUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isOnlyCloudUser
  );
  const isOnlyPremAssetUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isOnlyPremAssetUser
  );
  const isBothCloudAndPremAssetUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isBothCloudAndPremAssetUser
  );



  return (
    <>
      {isNewUserTrue ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "80vh",
          }}
        >
          <img src={NoData_img1} alt="" style={{ width: 300 }} />
          <Typography
            variant="body2"
            sx={{ fontWeight: 500, fontSize: "18px", mt: 2 }}
          >
            Welcome to Spark!
          </Typography>
          {hasPermissions(ROLES_ROUTE.NEW_SCAN) ? (
            <>
              <Typography
                variant="body2"
                sx={{ fontWeight: 400, fontSize: "14px", mb: 2 }}
              >
                Let's get started by scanning your first asset by clicking the
                button below.
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate("/on-premises/new-newscan")}
              >
                Scan Now
              </Button>
            </>
          ) : (
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, fontSize: "14px", mb: 2 }}
            >
              No compliance assets found.
            </Typography>
          )}
        </Box>
      ) : (
        <Box>
          <Grid container spacing={3}>
            {/* 60-40 Split Section - Trends and Tags */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                {/* Compliance Trends - 60% */}
                <Grid item xs={12} md={9}>
                  <Box
                    sx={{
                      height: {
                        lg: "45vh",
                      },
                    }}
                  >
                    <ComplianceTrendsComponent height="45vh" />
                  </Box>
                </Grid>

                {/* Tags - 40% */}
                <Grid item xs={12} md={3}>
                  <Box
                    sx={{
                      height: {
                        lg: "45vh",
                      },
                      bgcolor:
                        theme.palette.mode === "dark"
                          ? "rgba(255, 255, 255, 0.05)"
                          : "#FFFFFF",
                    }}
                  >
                    <Tags height="45vh" />
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            {/* 60-40 Split Section - Compliance Widgets and Misconfiguration */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {/* Compliance Widgets - 60% */}
                <Grid item xs={12} md={7}>
                  <Grid
                    container
                    spacing={3}
                    justifyContent="flex-start"
                    columnSpacing={2}
                  >
                    {loading ? (
                      <>
                        {[1, 2, 3, 4, 5, 6].map((index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={index}
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <Box
                              sx={{
                                height: "100%",
                                minHeight: 280,
                                width: "280px",
                                overflow: "hidden",
                              }}
                            >
                              <ComplianceWidgetSkeleton />
                            </Box>
                          </Grid>
                        ))}
                      </>
                    ) : (
                      <>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <Box
                            sx={{
                              height: "100%",
                              minHeight: 280,
                              width: "280px",
                              overflow: "hidden",
                            }}
                          >
                            <DoTDashboardCard />
                          </Box>
                        </Grid>
                        {complianceData.map((data, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={index}
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <Box
                              sx={{
                                height: "100%",
                                minHeight: 280,
                                width: "280px",
                                overflow: "hidden",
                              }}
                            >
                              <ComplianceWidget
                                data={data}
                                controlTypes={controlTypes}
                                setComplianceData={setComplianceData}
                              />
                            </Box>
                          </Grid>
                        ))}
                      </>
                    )}
                  </Grid>
                </Grid>

                {/* Top Misconfiguration - 40% */}
                <Grid item xs={12} md={5}>
                  <Box
                    sx={{
                      position: { xs: "relative", md: "sticky" },
                      top: { xs: 0, md: 16 },
                      maxHeight: { xs: "none", md: "calc(100vh - 32px)" },
                      height: "100%",
                    }}
                  >
                    <AssetsTable />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default ComplianceDashboard;


